import React from 'react'
import QuoteBoxMini from './QuoteBoxMini'
import VideoLightbox from './VideoLightbox'
import PreviewCompatibleImage from './PreviewCompatibleImage'
import MarkdownRenderer from './MarkdownRenderer'
import { toSwedishDate } from './helper functions/toSwedishDate'
import CtaButton from './CtaButton'

const CourseColumns = ({
  image,
  quote,
  quoteName,
  preheadline,
  headline,
  text,
  videolink,
  videoCtaText,
  nextOccasion,
  ctaButtonUrl,
  ctaButton,
}) => {
  return (
    <section className="section">
      <div className="columns is-12">
        {/* Left Block */}
        <div className="column is-half">
          <div className="columns">
            <div className="column is-three-quarters mr-1 is-clipped">
              <PreviewCompatibleImage imageInfo={{ image: image }} />
            </div>
          </div>
        </div>

        {/* Right Block */}
        <div className="column is-half is-flex is-flex-wrap-wrap is-flex-direction-column-reverse-mobile">
          <div>
            <QuoteBoxMini quote={quote} quoteName={quoteName} />
          </div>
          <div>
            <div className="mt-4">
              <h6 className="is-uppercase has-text-primary is-6">
                {preheadline}
              </h6>
            </div>

            <h1 className="title">{headline}</h1>
            <div className="columns">
              <div className="column">
                <MarkdownRenderer markdown={text} />
              </div>
            </div>

            <div
              className={
                nextOccasion &&
                `is-flex is-align-items-center is-flex-wrap-wrap`
              }
            >
              {videolink ? (
                <div className="mb-3">
                  <VideoLightbox videolink={videolink} ctaText={videoCtaText} />
                </div>
              ) : null}
              {nextOccasion && (
                <div
                  className={`is-family-secondary is-uppercase is-flex is-align-items-center mb-3`}
                >
                  <div
                    className={`is-flex is-align-items-center ${
                      videolink ? 'ml-3' : ''
                    } mr-2`}
                  >
                    <img
                      src="/img/siteimg/klocka.svg"
                      alt="Klocka"
                      width={20}
                      height={20}
                      quality={100}
                      style={{ maxWidth: 'unset' }}
                    />
                  </div>
                  Nästa kurstillfälle {toSwedishDate(nextOccasion)}
                </div>
              )}
            </div>

            <CtaButton
              text={ctaButton}
              url={ctaButtonUrl}
              customClass="button mt-4 mb-6"
            />
          </div>
        </div>
      </div>
    </section>
  )
}

export default CourseColumns
